import { z } from "zod";

export const bulkCreateVehicleResponse = z.array(
  z.object({
    isNew: z.boolean(),
    isUpdated: z.boolean(),
    uuid: z.uuid(),
  }),
);

export type BulkCreateVehicleResponse = z.infer<
  typeof bulkCreateVehicleResponse
>;
